import { FC } from 'react';
import { Box, Text } from 'theme-ui';
import PhotoSidebar from '@picsart/rc/old/PhotoSidebar';
import { IPhotoSidebar } from '@picsart/rc/types/containerComponents/PhotoSidebar/types';
import { DragDropContext } from 'react-beautiful-dnd';
import { addPhotoSidebarImageToScene, uploadFiles } from 'modules/scenes';
import { useDispatch, useSelector } from 'react-redux';
import { noop } from 'utils/noop';
import { FileInputProps, FileInputChildrenType, FileInput } from 'shared/FileInput';
import { UploadBtn } from '../shared/UploadBtn';
import { ACCEPTED_CONTENT } from 'constants/filetypes';
import analytics from 'utils/analytics';
import { useTranslator } from '@picsart/rc/services/localization';
import { getUserPaidItems } from 'modules/oneTimePayment';

export const UploadContent = ({
  type,
  position = 'absolute'
}: {
  type?: 'image' | 'video';
  position?: 'absolute' | 'relative';
}) => {
  const dispatch = useDispatch();
  const handleUpload: FileInputProps['onChange'] = files => {
    dispatch(uploadFiles(files));
  };

  const handleClick = () => {
    analytics.upload(type);
  };

  const translator = useTranslator();
  return (
    <Box
      sx={{
        position,
        bottom: '0px',
        zIndex: 'toolBar',
        left: 0,
        width: '100%',
        px: 4,
        pb: 1,
        pt: 6,
        bg: 'background'
      }}
    >
      <FileInput onChange={handleUpload} accept={ACCEPTED_CONTENT}>
        {(props: FileInputChildrenType) => (
          <UploadBtn onClickHandler={handleClick} loading={false} {...props}>
            {translator('Upload')}
          </UploadBtn>
        )}
      </FileInput>
      <Text
        variant="body"
        sx={{
          color: 'grey7',
          fontSize: 1,
          opacity: 0.6,
          fontWeight: 'heading',
          mt: 2,
          textAlign: 'center'
        }}
      >
        {translator('or drag and drop your files here')}
      </Text>
    </Box>
  );
};

export const PhotoSidebarTool: FC = () => {
  const dispatch = useDispatch();
  const handleSelectPhoto: IPhotoSidebar['handleSelectPhoto'] = (
    _e,
    id,
    url,
    photo,
    _selectedTabName,
    loaded = noop
  ) => {
    dispatch(addPhotoSidebarImageToScene(url, photo, String(id), loaded));
  };

  const userPaidItems = useSelector(getUserPaidItems);

  return (
    <Box
      sx={{
        bg: 'background',
        flex: '1',
        position: 'relative',
        height: '100%'
      }}
    >
      <DragDropContext onDragEnd={noop}>
        <PhotoSidebar
          analyticsOrigin="video_editor"
          experimentId=""
          openUrlModal={noop}
          handleDropPhoto={noop}
          handleSelectPhoto={handleSelectPhoto}
          purchasedItems={userPaidItems}
        />
      </DragDropContext>
      <UploadContent type="image" />
    </Box>
  );
};
